import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerService } from '../../service/server/server.service';
import { ScrollToService, ScrollToConfigOptions } from '@nicky-lenaers/ngx-scroll-to';


@Component({
  selector: 'app-sale-comment',
  templateUrl: './sale-comment.component.html',
  styleUrls: ['./sale-comment.component.scss']
})
export class SaleCommentComponent implements OnInit, OnDestroy {
  public isOnline: any;
  public loading = false;
  public subscription: Subscription;
  public err: string; public err_validation: boolean = false;
  public err_internet_text: string; public err_internet_validation: boolean;
  public server: any;
  public site: any;
  public lang: any;
  public username: any;
  public user_id: any;
  placeholder: string;
  show_excel: boolean = false;


  public list_comment: any = [];
  public id: number;
  public comment_text: any;
  user_info: any;
  export_code: any;

  constructor(public serverService: ServerService, public router: Router
    , @Inject(MAT_DIALOG_DATA) public dialog_data: any
    , public dialog: MatDialog
    , public dialogRef: MatDialogRef<SaleCommentComponent>
    , private matSnackBar: MatSnackBar
    , private _scrollToService: ScrollToService
  ) {
    if (dialog_data != null) {
      this.id = dialog_data.id;
    }
  }//end consructor

  ngOnInit() {
    this.serverService.status1(2);
    this.lang = JSON.parse(<any>localStorage.getItem('lang'));
    this.user_info = JSON.parse(<any>localStorage.getItem('user_info'));
    this.username = this.user_info.username;
    this.user_id = this.user_info.user_id;
    this.server = this.serverService.get_server();
    this.site = localStorage.getItem('site');
    if (this.lang == 1) {
      this.placeholder = "پیام خود را اینجا تایپ کنید";
    } else {
      this.placeholder = "Type your message here";
    }
    this.get_comments(1);




  }




  scroll() {
    const config: ScrollToConfigOptions = {
      target: 'bottom',
      offset: -20
    };
    this._scrollToService.scrollTo(config);
  }

  printWindow(): any {
    var virtualWindow: any = window.open('', '_blank  ', "screenX=1,screenY=1,left=1,top=1,width=" + screen.availWidth + ",height=" + screen.availHeight);
    virtualWindow.document.write('<html><head><title>Print1</title>');
    virtualWindow.document.write('<link rel="stylesheet" type="text/css" href="/assets/styles.scss"><link rel="stylesheet" type="text/css" href="/assets/comment.scss">');
    //virtualWindow.document.close(); // necessary for IE >= 10
    //virtualWindow.focus(); // necessary for IE >= 10*/
    //virtualWindow.document.write('</head><body>' + <any>document.getElementById('dialog-print').innerHTML + '</body>');
    virtualWindow.document.write('<script type="text/javascript">');
    virtualWindow.document.write('window.addEventListener("click", (event)=>{window.print(); window.close();})');
    //virtualWindow.document.write('window.onload = (event)=>{window.print(); window.close();})');

    virtualWindow.document.write('</script>');
    virtualWindow.document.write('</html>');


    //virtualWindow.focus;
    //virtualWindow.print();
    //virtualWindow.close();

    return true;
  }






  get_comments(excel) {
    if (this.serverService.check_internet()['status'] == false) {
      this.err_internet_validation = true;
      this.err_internet_text = this.serverService.check_internet()['title'];
      return;
    }//end if
    else { this.err_internet_validation = false; }
    this.loading = true;
    this.show_excel = false;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 1521, 'id': this.id, export_excel: excel, lang: this.lang }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          this.list_comment = [];
          for (var i = 0; i < res['num']; i++) {
            if (res['result'][0].user_logo) {
              res['result'][i].logo = res['result'][0].user_site_logo + "/" + res['result'][0].user_logo;
            } else {
              res['result'][i].logo = this.serverService.get_default_user_logo();
            }

            this.list_comment.push(res['result'][i]);
            this.list_comment[i].comment = this.serverService.isUnicode(this.list_comment[i].sale_items_comment_comment);
          }//end for
          this.recieve_message(false, "", "", 1, "", "");
        }//end if this.data['status'] == 1
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }//end else
      }//end res
    )//end
  }//comment

  change_dir(value, box) {
    this.serverService.direction_text(value, box);
  }



  send_comment(id) {
    if (this.serverService.check_internet()['status'] == false) {
      this.err_internet_validation = true;
      this.err_internet_text = this.serverService.check_internet()['title'];
      return;
    }//end if
    else { this.err_internet_validation = false; }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 1520, 'id': id, 'comment': this.comment_text, 'user_id': this.user_id }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          this.comment_text = "";
          this.show_excel = false;
          res['result'][0].comment = this.serverService.isUnicode(res['result'][0].sale_items_comment_comment);
          if (res['result'][0].user_logo) {
            res['result'][0].logo = res['result'][0].user_site_logo + "/" + res['result'][0].user_logo;
          } else {
            res['result'][0].logo = this.serverService.get_default_user_logo();
          }
          this.list_comment.push(res['result'][0]);

          //this.last_comment = res['result'][res['num']-1].sale_items_comment_comment;
          this.recieve_message(false, "", "", 1, "", "");
        }//end if this.data['status'] == 1
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }//end else
      }//end res
    )//end
  }//end menufiledelete


  close() {
    this.dialogRef.close();
  }//end dialogRef
  //**************************************************
  recieve_message(validation, en_message, pe_message, type, en_action, pe_action) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      if (this.lang == 1) this.matSnackBar.open(pe_message, pe_action, { duration: 2000 });
      if (this.lang == 2) this.matSnackBar.open(en_message, en_action, { duration: 2000 });
    }//end if
    else {
      this.matSnackBar.dismiss();
    }
  }
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}


